<template>
  <DBox
    :id="'cmp-accounting-costs-cost_sidewindow-cost_split_list'"
    :addButton="false"
    :addLink="true"
    @addClick="onAddClick"
    :addLinkLabel="`${$t('add_new')} ${$t('cost_split')}`"
  >
    <NTable
      :headers="headers"
      :items="list"
      :config="tableConfig"
      :showNoItems="false"
      :id="'accounting-costs-cost-sidewindow-cost_splits dbox1'"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('contract_cost_split')">
            <span
              @click.stop="(e) => openEditCostSplit(item)"
              class="ut-link"
              style="font-weight: bold"
              >{{ item.date }}</span
            >
          </td>
          <td v-bind="tdcon('assigned_to')">
            <span class="txtov">{{ item.cost_project_name }}</span>
          </td>
          <td v-bind="tdcon('description')">
            <span class="txtov">{{ item.description }}</span>
          </td>
          <td v-bind="tdcon('costgroup')">
            <span class="txtov">{{ item.cost_group_name }}</span>
          </td>
          <!-- <td v-bind="tdcon('costgroup')">
            <Dropdown2
              class="dbox1"
              :showLabel="false"
              :options="costGroupTV"
              :selected="costGroupTV.find((e) => e.value == item.cost_group_id)"
              :placeholder="$t('costgroup')"
              v-on:selectedChange="
                (e) => onDropdownChange('cost_group_id', e, item)
              "
              :bb="'0px'"
            />
          </td> -->

          <td v-bind="tdcon('amount_2dec_en')">
            <span>{{ item.amount_2dec_en }} {{ item.currency }}</span>
          </td>
          <td v-bind="tdcon('cost_amount')">
            <span
              >{{ item.amount_orig_curr }}
              {{ $store.getters.account.client.default_currency }}</span
            >
          </td>
          <td v-bind="tdcon('ignore_main')">
            <div class="ut-colcen">
              <v-layout row>
                <div class="ut-colcen">
                  <div
                    class="dt-checkbox v2 s1"
                    v-if="!isHideDeleteCostSplitIcon(item)"
                  >
                    <input
                      type="checkbox"
                      @click="(e) => onHoldFlagCheckBoxClicked(e, item)"
                      :name="'hold_flag'"
                      :checked="item && item.hold_flag == 1"
                    />
                    <div class="checkmark"></div>
                  </div>
                </div>
                &nbsp;
                <span
                  v-if="item.recoupable_txt === 'Do not Recoup'"
                  class="txtov"
                  >{{ item.recoupable_txt }}</span
                >
                <span
                  v-if="item.recoupable_txt !== 'Do not Recoup'"
                  class="ut-link"
                  style="font-weight: bold"
                  @click.stop="onRecoupStatusClick(item)"
                  >{{ item.recoupable_txt }}</span
                >
              </v-layout>
            </div>
          </td>
          <td v-bind="tdcon('options')">
            <img
              src="static/icons/delete.svg"
              @click.stop="(e) => deleteCostSplit(item)"
              class="dt-icon s2 v5"
              alt
              v-if="!isHideDeleteCostSplitIcon(item)"
            />
          </td>
        </tr>
      </template>
    </NTable>
    <template slot="bottomRight">
      <div class="ut-flex ut-fh ut-mr-10px">
        <div style="color: var(--text-secondary)">
          {{$t('total_cost_split_amount')}}:&nbsp;
        </div>
        <div style="min-width: 40px; text-align: right">
          <b
            >{{ selectedCostsDetails.amount }}
            {{ $store.getters.account.client.default_currency }}</b
          >
        </div>
        <div style="flex-grow: 1">
          <button class="dt-button v5 s8 txtov" @click="accountAllCostSplit">
            {{$t('account_all')}}
          </button>
        </div>
      </div>
    </template>
  </DBox>
</template>

<script>
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
import { AccountingStoreNamespace as storeNS } from "../../store";
import NTable from "@/plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import { CostsService } from "../../services/costs.service";
import { createTableHeader } from "../../../../plugins/datatable";
import DBox from "@dtplugins/dbox/dbox";
import { createTV, tv } from "../../../../models/text-value.model";
import * as ActionTypes from "../../store/types";
import { mapActionObject, mapGetterObject } from "../../../../store/global";
import { costsActions } from "../../store/costs/actions";
import {
  createModalMixin,
  openModalRoute,
  openModalRoute2,
} from "../../../../dt-plugins/modal/modal.mixin";
export default {
  components: {
    NTable,
    DBox,
  },
  props: ["selectedCostsDetails"],
  data: function () {
    return {
      costSplits: [],
      invoiceHeaders: [],
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
      }),
    };
  },
  computed: {
    headers: function () {
      return [
        createTableHeader("contract_cost_split"),
        createTableHeader("assigned_to"),
        createTableHeader("description"),
        createTableHeader("costgroup"),
        createTableHeader("amount_2dec_en", { text: false, ta: "right" }),
        createTableHeader("cost_amount", { ta: "right" }),
        createTableHeader("ignore_main", { minw: 250 }),
        createTableHeader("options", { text: false, mw: 30, ta: "left" }),
      ];
    },

    list: function () {
      return this.selectedCostsDetails?.cost_splits || [];
    },
    costGroupTV: function () {
      return createTV(
        this.selectedCostsDetails?.cost_groups,
        "cost_group_name",
        "cost_group_id"
      );
    },

    costAmountTotal: function () {
      let total = 0;
      this.list.forEach((row) => {
        total += Number(row.recoupable_txt);
      });
      return total.toFixed(2);
    },
  },
  methods: {
    ...mapActionObject(storeNS, costsActions),
    onDropdownChange: function (name, value, item) {
      item[name] = value.value;
      this.$emit("changed", {
        name,
        value: value.value,
        kVal: item.cost_split_id,
        table: "cost_splits",
      });
      this.updateData(item);
    },
    updateData: function (item) {
      const cost_splits = this.selectedCostsDetails.cost_splits.map((b) => {
        if (b.cost_split_id === item.cost_split_id) {
          b = {
            ...item,
          };
        }
        return b;
      });

      this[ActionTypes.AccountingCostSplits.SET.ALL]({
        invoice_id: this.selectedCostsDetails?.invoice?.invoice_id,
        cost_splits: cost_splits || [],
      });
    },
    onAddClick: function () {
      this.$emit("add_click", "add_cost_split");
    },
    getSelectedDebitCreditItem: function (itemValue) {
      let selectedItem = this.costGroupTV.find((row) => row.value == itemValue);
      return selectedItem;
    },
    isHideDeleteCostSplitIcon: function (costSplit) {
      return (
        (costSplit &&
          costSplit.recoupable_txt &&
          costSplit.recoupable_txt.startsWith(
            this.$t("recoupable_accounted")
          )) ||
        false
      );
    },
    onCostGroupTVSelect: function (selectedItem, costSplit) {
      this.selectedCostsDetails.cost_splits =
        this.selectedCostsDetails?.cost_splits.map((row) => {
          if (row.cost_split_id == costSplit.cost_split_id) {
            row.cost_group_id = selectedItem.value;
          }
          return row;
        });

      this.$emit(
        "modify",
        costSplit.cost_split_id,
        "cost_group_id",
        selectedItem.value
      );
    },
    onRelationTextBoxBlur: function (e, costSplit) {
      const { id, value } = e.target;
      this.$emit("modify", costSplit.cost_split_id, id, value);
    },
    // deleteCostSplit(costSplit) {
    //   this.costSplits = this.costSplits.filter(
    //     (row) => row.cost_split_id != costSplit.cost_split_id
    //   );
    //   this.$emit("delete", costSplit);
    // },
    deleteCostSplit: async function (item) {
      const confirmationResult = await confirmDelete(
        "cost_splits",
        item.description
      );
      if (confirmationResult === "OK") {
        const res = await CostsService.costSplitsDelete(item.cost_split_id);
        const cost_splits = this.selectedCostsDetails.cost_splits.filter(
          (b) => b.cost_split_id !== item.cost_split_id
        );
        this[ActionTypes.AccountingCostSplits.SET.ALL]({
          invoice_id: this.selectedCostsDetails?.invoice?.invoice_id,
          cost_splits: cost_splits || [],
        });
      }
    },

    onHoldFlagCheckBoxClicked: function (e, costSplit) {
      let flag = e.target.checked ? { hold_flag: "checked" } : {};
      CostsService.costSplitUpdateHoldFlag(costSplit.cost_split_id, flag).then(
        (res) => {
          const cost_splits = this.selectedCostsDetails.cost_splits.map(
            (row) => {
              if (row.cost_split_id == costSplit.cost_split_id) {
                row.recoupable_txt = res.data.recoupable_txt;
                row.hold_flag = e.target.checked ? 1 : 0;
              }
              return row;
            }
          );
          this[ActionTypes.AccountingCostSplits.SET.ALL]({
            invoice_id: this.selectedCostsDetails?.invoice?.invoice_id,
            cost_splits: cost_splits || [],
          });
          CostsService.invoiceTotalCostSplit(
            this.selectedCostsDetails.invoice.invoice_id
          ).then((res) => {
            const amount = res.data.amount;
            this[ActionTypes.InvoiceTotalCostSplit.SET.ALL]({
              invoice_id: this.selectedCostsDetails?.invoice?.invoice_id,
              amount: amount || 0,
            });
          });
        }
      );
    },

    onClickAddCostlinesAdd() {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "accounting_cost_split_add",
          invoice_id: this.selectedCostsDetails.invoice.invoice_id,
        },
      });
    },
    openEditCostSplit: function (item) {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "cost_split_edit_form",
          cost_split_id: item.cost_split_id,
        },
      });
    },
    onRecoupStatusClick: async function (item) {
      const { cost_split_id, hold_flag, recoupable_txt } = item;
      // if (recoupable_txt === "Account Recoupables") {
      //   CostsService.createCostSplit(cost_split_id).then((res) => {
      //     const cost_splits = this.selectedCostsDetails.cost_splits.map(
      //       (row) => {
      //         if (row.cost_split_id == cost_split_id) {
      //           row.recoupable_txt = res.data.recoupable_txt;
      //         }
      //         return row;
      //       }
      //     );
      //     this[ActionTypes.AccountingCostSplits.SET.ALL]({
      //       invoice_id: this.selectedCostsDetails?.invoice?.invoice_id,
      //       cost_splits: cost_splits || [],
      //     });
      //     CostsService.invoiceTotalCostSplit(
      //       this.selectedCostsDetails.invoice.invoice_id
      //     ).then((res) => {
      //       const amount = res.data.amount;
      //       this[ActionTypes.InvoiceTotalCostSplit.SET.ALL]({
      //         invoice_id: this.selectedCostsDetails?.invoice?.invoice_id,
      //         amount: amount || 0,
      //       });
      //     });
      //   });
      //   return;
      // }
      if (hold_flag == 1) {
        return;
      }
      console.log("recoupable_txt", recoupable_txt);
      switch (recoupable_txt) {
        case "Open Advance": {
          openModalRoute2(this, "costOpenAdvance", {
            cost_split_id,
          });

          break;
        }
        case "Not Recoupable": {
          openModalRoute2(this, "costRecoupables", {
            cost_split_id,
          });

          break;
        }
        case "Do not Recoup": {
          break;
        }
        case "Account Recoupables": {
          CostsService.createCostSplit(cost_split_id).then((res) => {
            const cost_splits = this.selectedCostsDetails.cost_splits.map(
              (row) => {
                if (row.cost_split_id === cost_split_id) {
                  row.recoupable_txt = res.data.recoupable_txt;
                }
                return row;
              }
            );
            this[ActionTypes.AccountingCostSplits.SET.ALL]({
              invoice_id: this.selectedCostsDetails?.invoice?.invoice_id,
              cost_splits: cost_splits || [],
            });
            CostsService.invoiceTotalCostSplit(
              this.selectedCostsDetails.invoice.invoice_id
            ).then((res) => {
              const amount = res.data.amount;
              this[ActionTypes.InvoiceTotalCostSplit.SET.ALL]({
                invoice_id: this.selectedCostsDetails?.invoice?.invoice_id,
                amount: amount || 0,
              });
            });
          });
          break;
        }
        default: {
          if (recoupable_txt.startsWith("Accounted:")) {
            openModalRoute2(this, "costRecoupables", {
              cost_split_id,
            });
          }
        }
      }
    },
    accountAllCostSplit() {
      if (this.selectedCostsDetails) {
        CostsService.costSplitAll(
          this.selectedCostsDetails.invoice.invoice_id
        ).then((res) => {
          const cost_splits = res.data.cost_splits;
          this[ActionTypes.AccountingCostSplits.SET.ALL]({
            invoice_id: this.selectedCostsDetails?.invoice?.invoice_id,
            cost_splits: cost_splits || [],
          });
        });
      }
    },
  },
};
</script>


<style lang="scss" scoped>
.cmp-accounting-costs-cost_sidewindow-cost_split_list {
  // .dt-ntable {
  //   --ntable-height: 220px !important;
  // }

  // .cost-splits-summary {
  //   display: flex;
  //   padding: 10px;
  // }

  // .dt-ntable {
  //   td:first-child {
  //     font-weight: 700;
  //     color: black;
  //   }
  //   th:nth-child(1),
  //   td:nth-child(1) {
  //     // flex: 0.8;
  //   }
  //   th:nth-child(2),
  //   td:nth-child(2) {
  //     //flex: 1;
  //   }
  //   th:nth-child(3),
  //   td:nth-child(3) {
  //     //flex: 1;
  //   }
  //   th:nth-child(4),
  //   td:nth-child(4) {
  //     // flex: 0.8;
  //   }
  //   th:nth-child(5),
  //   td:nth-child(5) {
  //     //flex: 0.6;
  //   }
  //   th:nth-child(6),
  //   td:nth-child(6) {
  //     // flex: 0.2 !important;
  //   }
  //   th:nth-child(6) {
  //     //text-align: left !important;
  //   }
  //   th:nth-child(7),
  //   td:nth-child(7) {
  //     // flex: 1 !important;
  //     // text-align: left !important;
  //   }
  //   th:nth-child(8),
  //   td:nth-child(8) {
  //     //  flex: 0.2 !important;
  //   }
  // }

  // .dropdown.box {
  //   border: none !important;
  // }
  // .dropdown.box .dropdown--main {
  //   margin-left: 0 !important;
  // }

  // .dropdown .dropdown--main {
  //   padding: 0 !important;
  // }
  // .dropdown .dropdown--main .dropdown--main__text {
  //   padding-top: 3px !important;
  // }
}
</style>
